import MPSessionStorage from "@/services/MPSessionStorage";
var UNIWABA_APP_URLS = {
    local: "http://localhost:3000",
    staging: "https://staging-app.360dialog.com",
    rc: "https://rc-app.360dialog.com",
    production: "https://app.360dialog.com",
};
export var getUniwabaAppUrl = function () {
    if (typeof window === "undefined") {
        return UNIWABA_APP_URLS.production;
    }
    var hostname = window.location.hostname;
    if (hostname === "localhost") {
        return UNIWABA_APP_URLS.local;
    }
    if (hostname.includes("staging") || hostname.includes("hub-staging")) {
        return UNIWABA_APP_URLS.staging;
    }
    if (hostname.includes("rc-") || hostname.includes("rc.")) {
        return UNIWABA_APP_URLS.rc;
    }
    return UNIWABA_APP_URLS.production;
};
/**
 * Returns the uniwaba redirect URL with ?channel={channelId} when available.
 * Reads channel ID from session storage (stored after successful onboarding).
 */
export var getUniwabaRedirectUrl = function () {
    var baseUrl = getUniwabaAppUrl();
    var channelId = MPSessionStorage.get(MPSessionStorage.keys.ONBOARDED_CHANNEL_ID);
    if (channelId) {
        return "".concat(baseUrl, "?channel=").concat(encodeURIComponent(channelId));
    }
    return baseUrl;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5pd2FiYVJlZGlyZWN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidW5pd2FiYVJlZGlyZWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sZ0JBQWdCLE1BQU0sNkJBQTZCLENBQUM7QUFFM0QsSUFBTSxnQkFBZ0IsR0FBRztJQUN2QixLQUFLLEVBQUUsdUJBQXVCO0lBQzlCLE9BQU8sRUFBRSxtQ0FBbUM7SUFDNUMsRUFBRSxFQUFFLDhCQUE4QjtJQUNsQyxVQUFVLEVBQUUsMkJBQTJCO0NBQy9CLENBQUM7QUFFWCxNQUFNLENBQUMsSUFBTSxnQkFBZ0IsR0FBRztJQUM5QixJQUFJLE9BQU8sTUFBTSxLQUFLLFdBQVcsRUFBRTtRQUNqQyxPQUFPLGdCQUFnQixDQUFDLFVBQVUsQ0FBQztLQUNwQztJQUVELElBQU0sUUFBUSxHQUFHLE1BQU0sQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDO0lBRTFDLElBQUksUUFBUSxLQUFLLFdBQVcsRUFBRTtRQUM1QixPQUFPLGdCQUFnQixDQUFDLEtBQUssQ0FBQztLQUMvQjtJQUVELElBQUksUUFBUSxDQUFDLFFBQVEsQ0FBQyxTQUFTLENBQUMsSUFBSSxRQUFRLENBQUMsUUFBUSxDQUFDLGFBQWEsQ0FBQyxFQUFFO1FBQ3BFLE9BQU8sZ0JBQWdCLENBQUMsT0FBTyxDQUFDO0tBQ2pDO0lBRUQsSUFBSSxRQUFRLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxJQUFJLFFBQVEsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLEVBQUU7UUFDeEQsT0FBTyxnQkFBZ0IsQ0FBQyxFQUFFLENBQUM7S0FDNUI7SUFFRCxPQUFPLGdCQUFnQixDQUFDLFVBQVUsQ0FBQztBQUNyQyxDQUFDLENBQUM7QUFFRjs7O0dBR0c7QUFDSCxNQUFNLENBQUMsSUFBTSxxQkFBcUIsR0FBRztJQUNuQyxJQUFNLE9BQU8sR0FBRyxnQkFBZ0IsRUFBRSxDQUFDO0lBQ25DLElBQU0sU0FBUyxHQUFHLGdCQUFnQixDQUFDLEdBQUcsQ0FDcEMsZ0JBQWdCLENBQUMsSUFBSSxDQUFDLG9CQUFvQixDQUMzQyxDQUFDO0lBQ0YsSUFBSSxTQUFTLEVBQUU7UUFDYixPQUFPLFVBQUcsT0FBTyxzQkFBWSxrQkFBa0IsQ0FBQyxTQUFTLENBQUMsQ0FBRSxDQUFDO0tBQzlEO0lBQ0QsT0FBTyxPQUFPLENBQUM7QUFDakIsQ0FBQyxDQUFDIn0=